<template>
<div>
  <!-- View data modal template -->
  <b-modal ref="view-lb" hide-footer @hide="hideLBModal">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('maintenance.data_objects.view.title') }}
      </h4>
    </div>
    <b-alert v-if="error.length"
             show
             variant="danger"
             qid="create-p-error"
    >
      {{ error }}
    </b-alert>

    <label class="mt-3" v-if="object.data_object && object.data_object.name">
      {{ $t('maintenance.data_objects.create.name_label') }}
    </label>
    <br>
    <span v-if="object.data_object && object.data_object.name">
      {{ object.data_object.name }}
    </span>
    <br>

    <label class="mt-3" v-if="object.data_object && object.data_object.category">
      {{ $t('maintenance.data_objects.create.category_label') }}
    </label>
    <br>
    <span v-if="object.data_object && object.data_object.category">
      <span class="badge badge-info">
        {{ object.data_object.category }}
      </span>
    </span>
    <br>

    <label class="mt-3" v-if="object.data_object && object.data_object.classification">
      {{ $t('maintenance.data_objects.create.classification_label') }}
    </label>
    <br>
    <span v-if="object.data_object && object.data_object.classification">
      <span class="badge badge-info">
        {{ $t('classification.' + $options.filters.slugify(object.data_object.classification)) }}
      </span>
    </span>
    <br>

    <label class="mt-3" v-if="object.data_object && object.data_object.business_classification">
      {{ $t('maintenance.data_objects.create.business_classification_label') }}
    </label>
    <br>
    <span v-if="object.data_object && object.data_object.business_classification">
      <span class="badge badge-info">
        {{ $t('classification.' + $options.filters.slugify(object.data_object.business_classification)) }}
      </span>
    </span>
    <br>

    <label class="mt-3" v-if="object.data_object && object.data_object.tags_translated && object.data_object.tags_translated.length">
      {{ $t('maintenance.data_objects.create.tags_label') }}
    </label>
    <br>
    <span v-if="object.data_object && object.data_object.tags_translated && object.data_object.tags_translated.length">
      <span class="mr-1" v-for="tag in object.data_object.tags_translated" qid="p-tags-list">
        <span class="badge badge-info mb-1" :title="tag.name_translated">
          {{tag.name_translated | truncate(35)}}
        </span>
      </span>
    </span>
    <br>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hideLBModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.legal_basis.view.close') }}
    </b-button>
    <br>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'DataViewModal',
    data: function() {
      return {
        inputLink: '',
        selectedArticle: [],
        articles: [],
        error: '',
        showInput: false,
        showSingleLinkLabel: true,
        loadingItems: false,
        showArticleDescription: false,
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showLBModal()
        }
      }
    },
    methods: {
      showLBModal() {
        let self = this
        this.$refs['view-lb'].show()
      },
      hideLBModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-lb'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
